import useApi from "@/hooks/useApi";
import * as React from "react";

export default function useAdminUsers() {
  const [adminUsers, setAdminUsers] = React.useState<
    { userId: number; userName: string; displayName: string }[]
  >([]);
  const api = useApi();

  React.useEffect(() => {
    async function fetchAdminUsers() {
      try {
        const resp = await api.admin.get("api/kb/users");
        const users: any[] = await resp.json();
        setAdminUsers(Array.isArray(users) ? users : []);
      } catch (err) {
        console.error("Failed to fetch admin users:", err);
        setAdminUsers([]);
      }
    }

    fetchAdminUsers();
  }, []);

  return { adminUsers };
}
